import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[marketImageFailed]',
  standalone: true,
})
export class ImageFailedDirective {
  constructor(private el: ElementRef<HTMLImageElement>) {}
  @HostListener('error', ['$event'])
  onError() {
    this.el.nativeElement.src = 'assets/images/logo.jpg';
  }
}
